import { api } from './index';

const PATIENTS_PATH = '/api/internal/patients';

export type PreferenceKind = 'blocked' | 'favorite';

export type PatientCaregiverPreference = {
  id: number;
  patientId: number;
  caregiverId: number;
  kind: PreferenceKind;
  caregiverFullName: string;
  caregiverCareer: string | null;
  humanCaregiverCareer: string | null;
};

export interface PatientCaregiverPreferenceForm {
  kind: PreferenceKind;
  caregiverId: number;
}

export const patientCaregiverPreferencesApi = {
  index(patientId: number): Promise<PatientCaregiverPreference[]> {
    return api({
      method: 'get',
      url: `${PATIENTS_PATH}/${patientId}/caregiver_preferences`,
    }).then(response => response.data.patientCaregiverPreferences);
  },
  create(
    patientId: number,
    form: PatientCaregiverPreferenceForm,
  ): Promise<PatientCaregiverPreference> {
    return api({
      method: 'post',
      url: `${PATIENTS_PATH}/${patientId}/caregiver_preferences`,
      data: { caregiverPreference: form },
    }).then(response => response.data.patientCaregiverPreference);
  },
  destroy(patientId: number, id: number): Promise<void> {
    return api({
      method: 'delete',
      url: `${PATIENTS_PATH}/${patientId}/caregiver_preferences/${id}`,
    }).then(() => {});
  },
};
